/**
 * @voltxampere/ui — 4067 16-channel analog mux CMOS variant (Sprint 43-6, full simulation)
 *
 * Sprint 43 ADR-0063 introduced the `analog-mux-16` canonical engine
 * type. The 4067 routes one of sixteen analog channels to the common
 * output based on 4 binary select pins; this variant uses the
 * dedicated 22-pin definition (16 channels + 4 select + enable + common).
 *
 * Reference: TI CD4067B. 16 analog input channels (CH0..CH15), 4 binary
 * select pins (A/B/C/D), active-LOW INH. Vcc 3-15 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4067 = {
    id: "4067",
    nameTr: "4067 (16 Kanal Analog Mux CMOS, DIP-24)",
    nameEn: "4067 (16-Channel Analog Mux CMOS, DIP-24)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4067",
    schemaType: "analog-mux-16",
    defaultParams: {
        channelCount: 16,
        threshold: 2.5,
        enableActiveLow: true,
        rOn: 100,
        propagationDelay: 120e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4067.js.map